import { Avatar as MUIAvatar, AvatarProps as MUIAvatarProps } from '@mui/material';
import { S2 } from '../../theme';
import { mergeSX } from '../../services/helpers';

interface IBuildSXParams {
  width?: string | number;
  height?: string | number;
  backgroundColor?: string;
  marginRight?: string | number;
  outlineColor?: string;
}

const buildSX = ({
  width, height, backgroundColor, marginRight, outlineColor,
}: IBuildSXParams) => ({
  backgroundColor,
  marginRight,
  width,
  height,
  boxShadow: outlineColor && `0 0 0 2px ${outlineColor}`,
});

export interface IAvatarProps extends MUIAvatarProps, IBuildSXParams {}

const Avatar = (props: IAvatarProps) => {
  const {
    height = 24, width = 24, backgroundColor = S2, marginRight = '8px', sx, outlineColor, ...rest
  } = props;

  return (
    <MUIAvatar
      sx={mergeSX(buildSX({
        height, width, backgroundColor, marginRight, outlineColor,
      }), sx)}
      {...rest}
    />
  );
};

export default Avatar;
